import { useState } from 'react'

import {
  InvestmentEntity,
  InvestmentEntityCategory,
} from '@cash-web/protos/squareup/cash/marketdata/model/investment_entities.pb'

import { getTradableInvestmentEntitySearchResults } from './investmentEntityUtils'

const filteredEntities = (value: string, allInvestmentEntities: InvestmentEntity[]) =>
  getTradableInvestmentEntitySearchResults(allInvestmentEntities, value).slice(0, 20)

const mappedEntitiesByCategory = (
  categories: (InvestmentEntityCategory & { showIfEmpty?: boolean })[],
  allInvestmentEntities: InvestmentEntity[],
  multiSelect?: { selectedEntityTokens?: Set<string> }
) => {
  const categorizedEntities: { [key: string]: InvestmentEntity[] } = {}

  categories.forEach(({ name, investment_entities, showIfEmpty }) => {
    if (!investment_entities && !showIfEmpty) return

    const mappedEntities = investment_entities
      ? investment_entities
          .filter(({ investment_entity_token }) => investment_entity_token !== undefined)
          .filter(
            ({ investment_entity_token }) =>
              name === 'Selected' ||
              (investment_entity_token && !multiSelect?.selectedEntityTokens?.has(investment_entity_token))
          )
          .map(({ investment_entity_token }) =>
            allInvestmentEntities.find(({ token }) => token === investment_entity_token)
          )
          .filter((entity): entity is InvestmentEntity => !!entity)
      : []

    if (name && (showIfEmpty || mappedEntities.length > 0)) {
      categorizedEntities[name] = mappedEntities
    }
  })

  return categorizedEntities
}

type UseInvestmentListArgs = {
  allInvestmentEntities: InvestmentEntity[]
  categories: (InvestmentEntityCategory & { showIfEmpty?: boolean })[]
  multiSelect?: { selectedEntityTokens?: Set<string> }
}
export const useInvestmentList = ({ allInvestmentEntities, categories, multiSelect }: UseInvestmentListArgs) => {
  const [searchValue, setSearchValue] = useState('')
  const [searchResults, setSearchResults] = useState<InvestmentEntity[]>([])

  const handleSearchOnChange = ({ target: { value } }: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(value)
    if (value === '') {
      setSearchResults([])
      return
    }
    setSearchResults(filteredEntities(value, allInvestmentEntities))
  }

  const clearSearch = () => {
    setSearchValue('')
    setSearchResults([])
  }

  return {
    clearSearch,
    searchValue,
    searchResults,
    handleSearchOnChange,
    categorizedEntities: mappedEntitiesByCategory(categories, allInvestmentEntities, multiSelect),
  }
}
